import { getElectricalSafetyHmlReport } from "lib/api/getElectricalSafetyHmlReport";
import { useAppStore } from "lib/store/useAppStore";

export default function ElectricalSafetyHmlDownloadBtn({
  uploadId,
  fileName,
  label = "Download HML",
  onClick,
}) {
  const showAlert = useAppStore((s) => s.showAlert);

  if (!uploadId && typeof onClick !== "function") return null;

  const handleClick = async () => {
    if (typeof onClick === "function") {
      await onClick();
      return;
    }

    const result = await getElectricalSafetyHmlReport(uploadId, fileName);

    if (!result?.success) {
      showAlert({
        text: result.message || "Failed to download electrical safety HML report.",
        messageKey: result.messageKey,
        messageParams: result.messageParams,
        success: false,
        autoClose: true,
      });
    }
  };

  return (
    <button type="button" className="btn-bg-blue" onClick={handleClick}>
      {label}
    </button>
  );
}
